import registerLink from '../../../common/links/index';
import presentationalComponent from './Link';
import containerComponent from './LinkContainer';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbarV2/config/toolbarToolConfig';

export default () =>
    registerLink({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.RICH_TEXT, TOOLS.COLOR, TOOLS.MEDIA, { ...TOOLS.CAPTION, name: 'Description' }, TOOLS.REACTION],
        selectedTools: [
            TOOLBAR_TOOLS.COLOR,
            TOOLBAR_TOOLS.MEDIA,
            { ...TOOLBAR_TOOLS.CAPTION, name: 'Description' },
            TOOLBAR_TOOLS.REACTION,
            ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
        ],
        editingTools: [...TOOL_SETS.TEXT_EDITING_INLINE, TOOLBAR_TOOLS.TEXT_CENTERED],
    });
